import type { IMessage } from '@/lib/types/chat';

type StopNotices = Pick<IMessage, 'isCancelled' | 'isRepetitionStopped' | 'isShutdownStopped'>;

/**
 * Why a stored answer ends early, read off its metadata.
 *
 * Each flag puts its own line under the answer: the user's stop (KAN-940), the
 * loop watcher (KAN-958), or a deploy whose shutdown drain ran out before the
 * run was done (KAN-1469). The last one comes with ``cancelled`` and replaces
 * its wording, because "you stopped this" would be untrue.
 */
export const stopNoticesOf = (rawMeta: Record<string, unknown>): StopNotices => ({
  isCancelled: rawMeta['cancelled'] === true,
  isRepetitionStopped: rawMeta['repetition_stopped'] === true,
  isShutdownStopped: rawMeta['shutdown_stopped'] === true,
});
